import { render, staticRenderFns } from "./ExternalGameTab.vue?vue&type=template&id=2dc7770c&scoped=true&lang=pug"
import script from "./ExternalGameTab.vue?vue&type=script&lang=js"
export * from "./ExternalGameTab.vue?vue&type=script&lang=js"
import style0 from "./ExternalGameTab.vue?vue&type=style&index=0&id=2dc7770c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc7770c",
  null
  
)

export default component.exports